import { type App } from '~/app';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Enquiry Button Component');

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            mountEnquiryButton(listeners);
        })
        .catch((error:Error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Enquiry Button Component', error);
        });

    return function destroyEnquiryButton() {
        unMountEnquiryButton(listeners);

        app.logger.debug('[DXA] Enquiry Button Component destroyed');
    };
};

function mountEnquiryButton(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
    root: HTMLElement | null = null
) {
    let rootNode: Document | HTMLElement = document;
    if (root) rootNode = root;


    // Sticky enquiry button
    const enquiryButton: HTMLElement | null = document?.querySelector('.workplace-enquiry-button');
    if (enquiryButton) {
        enquiryButton.addEventListener('click', (event) => event.preventDefault());
        const boundingBox = enquiryButton.getBoundingClientRect();
        const topNavigationBar: HTMLElement = rootNode.querySelector('.top-navigation-bar')!;
        const footer = rootNode.querySelector('footer')!;

        const placeEnquiryButton = () => {
            enquiryButton.style.bottom = `unset`;
            enquiryButton.style.right = `unset`;
            enquiryButton.style.top = `unset`;
            enquiryButton.style.left = `unset`;
            enquiryButton.style.position = `sticky`;


            if (window.innerWidth > 769) {
                window.addEventListener('scroll',()=>{
                    const buttonMargin = 18 + (topNavigationBar ? topNavigationBar.offsetHeight + 85: 0);
                    const buttonTop = boundingBox.top - buttonMargin;
                    enquiryButton.style.top = (window.innerWidth > 769 ? `${buttonMargin}px` : `unset`)

                    enquiryButton.style.left = window.scrollY < buttonTop || (window.scrollY > buttonTop && (!footer ||
                            window.scrollY + enquiryButton.offsetTop + enquiryButton.offsetHeight < footer?.offsetTop)) ? "initial" : "-1000px";
                });
            }
            else {
                enquiryButton.style.position = 'fixed';
                enquiryButton.style.top = `unset`;
                enquiryButton.style.bottom = `36px`;
                enquiryButton.style.right = `32px`;
            }
        }

        const modalOverlay = document.querySelector<HTMLElement>(".button-modal-overlay")
        const modal = document.querySelector<HTMLElement>(".modal")

        const observer = new MutationObserver(function () {
            modalOverlay?.classList.toggle('invisible')
        })

        observer.observe(modal!, {
            attributes: true, 
            attributeFilter: ['class'],
            childList: false, 
            characterData: false
        })

        placeEnquiryButton();

        window.addEventListener('resize', placeEnquiryButton)
        listeners.push([window, 'resize', placeEnquiryButton]);
    }
  
}

export function unMountEnquiryButton(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}